import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import PURCHASEIRQClosingDateView from "../views/IrqClosingDateView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { date, object } from "yup";
import { getDateFourteenDaysFromNow } from "../util/getDateFourteenDaysFromNow";
import StatusCheck from "../components/StatusCheck";

class PurchaseIrqClosingDatePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    const minDate = getDateFourteenDaysFromNow();

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="purchaseIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            plannedClosingDate: date()
              .typeError("invalid date")
              .required("date required")
              .min(
                minDate,
                "you need at least 15 days for the closing process"
              ),
          })}
        >
          <PURCHASEIRQClosingDateView
            content={contentMap.PurchaseIrqClosingDatePage}
            navigationsAway={customNavigationMap.PurchaseIrqClosingDatePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(PurchaseIrqClosingDatePage);
